<script setup>
import { ref, onMounted } from 'vue'
import Header from '~/components/dashboard/partials/Header.vue'
import Sidebar from '~/components/dashboard/partials/Sidebar.vue'
import { useAppStore } from '~/stores/app'

const sidebarCollapsed = ref(false)
const sidebarOpen = ref(false)
const store = useAppStore()

const openSidebar = () => {
  sidebarOpen.value = true
}

const closeSidebar = () => {
  sidebarOpen.value = false
}

const toggleSidebarCollapse = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
}

onMounted(() => {
  store.initialiseStore()
})
</script>

<template>
  <VApp>
    <div
      class="layout-wrapper layout-nav-type-vertical"
      :class="{
        'layout-vertical-nav-collapsed': sidebarCollapsed,
        'layout-vertical-nav-open': sidebarOpen,
      }"
    >
      <aside class="layout-vertical-nav" :class="{ visible: sidebarOpen }">
        <Sidebar
          :collapsed="sidebarCollapsed"
          @close="closeSidebar"
          @toggle-collapse="toggleSidebarCollapse"
        />
      </aside>

      <div class="layout-content-wrapper">
        <Header @open-nav="openSidebar" />
        <main class="layout-page-content">
          <div class="page-content-container lp-container">
            <slot />
          </div>
        </main>
      </div>

      <div class="layout-overlay" :class="{ visible: sidebarOpen }" @click="closeSidebar" />
    </div>
  </VApp>
</template>
